import React from 'react'
import styles from './MyAccountViewItem.module.sass'

interface Props {
  label?: string
  value?: string
}

const MyAccountViewItem = (props: Props) => {

  const {
    label = '',
    value = '',
  } = props

  return <div className={styles.myAccountViewItem}>
    <span className={styles.label}>{label}</span>
    <span className={styles.value}>{value}</span>
  </div>
}

export default MyAccountViewItem
